import React, { useState, useRef, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { getListKiemKho, updateDataSearch } from "../../actions/KiemKho";

export const TableKiemKho = ({ listDaKiemKho, onLuuKiemKho, onKiemKho }) => {
  //Code
  const dispatch = useDispatch();
  const listKiemKhoFull = useSelector((state) => state.listKiemKhoFull); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchKiemKho); //dataSearchTaiSan dinh nghia o rootreducer

  useEffect(() => {
    dispatch(getListKiemKho(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListKiemKho(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListKiemKho(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listKiemKhoFull.TTotalQuantity;

  return (
    <>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers"  style={{ position: "sticky", padding: "2px", top: "14.2rem", zIndex: "999", background:"#FFFFFF", padding:"1px 0"}}>
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listKiemKhoFull.TTotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-26 flex-basis-23-6-sm">
                    <p className="text-center color7-bold">Mã tài sản</p>
                  </div>

                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="text-left color7-bold">Tên tài sản</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header  text-center color7-bold">
                      Mã hợp đồng
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-11-4-sm">
                    <p className="tab-header  text-center color7-bold">Kho</p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-15-sm">
                    <p className="tab-header text-center color7-bold">
                      Trạng thái
                    </p>
                  </div>
                  <div class="custom-table-header flex-basis-9 flex-basis-9-sm">
                    <p className="tab-header  text-center color7-bold">
                      Kiểm kho
                    </p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listKiemKhoFull={listKiemKhoFull.List}
                    listDaKiemKho={listDaKiemKho}
                    onKiemKho={onKiemKho}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12  col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12  col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
